import { CryptoJS, AES } from "./../../node_modules/crypto-js";

export class GUID {
  metaobjectArray;
  organizationId;

  constructor() {
    //first 3 characters are object code
    //next 7  are midcharacters of orgid (index position 3 to 9)
    //last 5 are random character

    // console.log(this.getGuId(this.orgId, "Contact"));
    //this.metaobjectArray = JSON.parse(this.decryptAES('metaobject'))
    this.metaobjectArray = JSON.parse(localStorage.getItem("crm_metaobjects"));
    console.log("this.metaobjectArray", this.metaobjectArray);
    this.organizationId = localStorage.getItem("crm_orgid");
  }

  decryptAES(key) {
    let cypher = localStorage.getItem(key);
    let originalData = AES.decrypt(cypher, "secret key");
    console.log("cypher  : ", originalData);
    // console.log(originalData.toString(CryptoJS.enc.Utf8));
    return originalData.toString(CryptoJS.enc.Utf8);
  }

  getobjFromArray(objName) {
    var code = "";
    this.metaobjectArray.forEach(function (value, index) {
      if (
        value.name.toString().toLowerCase() == objName.toString().toLowerCase()
      ) {
        code = value.code.toString();
        return;
      }
    });
    return code;
  }

  getRandamchars(count) {
    let text = "";
    let possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < count; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  }

  getGUID(objectName) {
    let objectCode = this.getobjFromArray(objectName);
    let orgId = this.organizationId.substring(3, 10);
    return objectCode + orgId + this.getRandamchars(5);
  }
}
